
<template>
  <w-modal
    v-model="value"
    class="modal-alert"
    :title="title"
    :hide-on-esc="false"
    :hide-on-overlay="false"
    :show-close="false"
    :show-close-button="showCloseButton"
    :close-button="closeButton"
    :submit-button="submitButton"
    :close-on-submit="false"
    @close="onCancel"
    @submit="onSubmit"
  >
    <slot>{{ description }}</slot>
  </w-modal>
</template>

<script>
import WModal from '@witkac/bootstrap4-components/src/components/modal.vue';

export default {
  props: {
    title: {
      type: String,
      default: 'Potwierdzenie'
    },
    description: String,
    value: Boolean,
    showCloseButton: Boolean,
    closeButton: String,
    submitButton: String
  },
  components: {
    WModal
  },
  methods: {
    onCancel() {
      this.$emit('cancel');
    },
    onSubmit() {
      this.$emit('submit');
    }
  }
};
</script>
